export const _captchaToken = 'captcha-token'
export const _captchaType = 'captcha-type'
export const _captchaTypeInvisible = 'web-invisible'
export const _captchaTypeVisible = 'web-visible'
export const _startSellingOnFlip = 'startSellingOnFlip'
export const _isChallengeRequired = 'isChallengeRequired'

export const CAPTCHA_ERROR_CODES = {
  REQUESTER_IP_NOT_PRESENT: 'CAPTCHA-1',
  TOO_MANY_FAILED_LOGIN_ATTEMPTS: 'CAPTCHA-2',
  CAPTCHA_TOKEN_INVALID: 'CAPTCHA-3',
  SCORE_TOOL_LOW: 'CAPTCHA-4',
}
